export const tourPricingQueryKeys = {
  byTour: (tourId: string) => ['tours', tourId, 'pricing'] as const,
  intallmentPriceRanges: (tourId: string, percentagesKey: string) =>
    [
      'tours',
      tourId,
      'pricing',
      'installmentPriceRanges',
      percentagesKey,
    ] as const,
};
